// extracted by mini-css-extract-plugin
module.exports = {"sportsSlider":"style_sportsSlider__tAB0F","default":"style_default__192z5"};